import React from 'react';
import { Body1, Headline } from '../../FontStyles';
import { Flex } from 'rebass';
import Styled from 'styled-components';

const Table = Styled(Flex)`
width: 100%;
flex-wrap: wrap;
`;

const TableRow = Styled(Flex)`
width: 100%;
border: ${props => props.theme.border};
box-sizing: border-box;
`;

const TableCell = Styled(Body1)`
padding: ${props => props.theme.space[3]}px
background-color: ${props => props.theme.colors.background};
width: 100%;
margin: 0;
outline: ${props => props.theme.border};
`;

class CalculatedValuesDisplay extends React.Component {
  render() {
    const inputs = this.props.inputs;
    return (
      <Table>
        <TableRow>
          <TableCell>
            <Headline>Calculated & input values</Headline>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>reducedDose:</TableCell>
          <TableCell>{inputs.training === 'reducedDose' ? 'True' : 'False'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Patient TDD:</TableCell>
          <TableCell>{inputs.dailyInsulinDose ? inputs.dailyInsulinDose : 'Not entered yet'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell> Patient Weight:</TableCell>
          <TableCell>{inputs.patientWeight ? inputs.patientWeight : 'Not entered yet'}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Pump TDD:</TableCell>
          <TableCell>{inputs.tddCalculated}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Basal Rate Percentage Selected</TableCell>
          <TableCell>{inputs.basalPercentageOfTDD}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Computed Basal Rate: TDD * Basal percentage</TableCell>
          <TableCell>{inputs.computedBasalRate} </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Computed ISF</TableCell>
          <TableCell>{inputs.computedISF} </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>Computed Insulin to carb ratio</TableCell>
          <TableCell>{inputs.computedInsulinToCarbRatio} </TableCell>
        </TableRow>
      </Table>
    );
  }
}

export default CalculatedValuesDisplay;
